/*global gtag*/

import Cookies from 'js-cookie';
let CookiesExpirationTime = 15; // days

let cookiesSwitchers = document.querySelectorAll('.js-vc-switch-input');
let cookiesBar = document.querySelector('.js-cookies-bar');
let cookiesBarAccept = document.querySelector('.js-cookies-bar-accept');
let cookiesBarDeny = document.querySelector('.js-cookies-bar-deny');
let cookiesAcceptAllBtn = document.querySelector('.js-vc-accept-all');
let cookiesDenyAllBtn = document.querySelector('.js-vc-deny-all');
let cookiesSaveBtn = document.querySelector('.js-vc-save-all');
let cookiesSaveNotice = document.querySelector('.js-vc-save-notice');

const cookieTypes = ['preferences', 'statistics', 'marketing'];

function grantCookiesGtm(type = 'all') {
  if (window.dataLayer) {
    window.dataLayer.push({ event: 'ws_consent_given' });

    if (type === 'all') {
      gtag('consent', 'update', {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        analytics_storage: 'granted',
        personalization_storage: 'granted',
      });
      window.dataLayer.push({
        event: 'cookie_consent_preferences',
        status: 'granted',
      });
      window.dataLayer.push({
        event: 'cookie_consent_statistics',
        status: 'granted',
      });
      window.dataLayer.push({
        event: 'cookie_consent_marketing',
        status: 'granted',
      });
    } else if (type === 'preferences') {
      gtag('consent', 'update', {
        personalization_storage: 'granted',
      });
      window.dataLayer.push({
        event: 'cookie_consent_preferences',
        status: 'granted',
      });
    } else if (type === 'statistics') {
      gtag('consent', 'update', {
        analytics_storage: 'granted',
      });
      window.dataLayer.push({
        event: 'cookie_consent_statistics',
        status: 'granted',
      });
    } else if (type === 'marketing') {
      gtag('consent', 'update', {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
      });
      window.dataLayer.push({
        event: 'cookie_consent_marketing',
        status: 'granted',
      });
    }
    window.dataLayer.push({ event: 'cookie_consent_update' });
  }
}

function denyCookiesGtm(type) {
  if (window.dataLayer) {
    window.dataLayer.push({ event: 'ws_consent_rejected' });

    if (type === 'all') {
      gtag('consent', 'update', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'denied',
        personalization_storage: 'denied',
      });
      window.dataLayer.push({
        event: 'cookie_consent_preferences',
        status: 'denied',
      });
      window.dataLayer.push({
        event: 'cookie_consent_statistics',
        status: 'denied',
      });
      window.dataLayer.push({
        event: 'cookie_consent_marketing',
        status: 'denied',
      });
    } else if (type === 'preferences') {
      gtag('consent', 'update', {
        personalization_storage: 'denied',
      });
      window.dataLayer.push({
        event: 'cookie_consent_preferences',
        status: 'denied',
      });
    } else if (type === 'statistics') {
      gtag('consent', 'update', {
        analytics_storage: 'denied',
      });
      window.dataLayer.push({
        event: 'cookie_consent_statistics',
        status: 'denied',
      });
    } else if (type === 'marketing') {
      gtag('consent', 'update', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
      });
      window.dataLayer.push({
        event: 'cookie_consent_marketing',
        status: 'denied',
      });
    }
    window.dataLayer.push({ event: 'cookie_consent_update' });
  }
}

function save_cookies_settings(location, value) {
  if (location === 'cookieSwitchers') {
    // Saved from settings page
    // We get value from switchers
    cookiesSwitchers.forEach((el) => {
      const cookieType = el.getAttribute('data-cookies-type');

      if (el.checked) {
        Cookies.set(`consent_${cookieType}`, 'given', {
          expires: CookiesExpirationTime,
        });
        grantCookiesGtm(cookieType);
      } else {
        Cookies.set(`consent_${cookieType}`, 'rejected', {
          expires: CookiesExpirationTime,
        });
        denyCookiesGtm(cookieType);
      }
    });
  } else {
    // Saved from cookie bar
    Cookies.set('consent_preferences', value, {
      expires: CookiesExpirationTime,
    });
    Cookies.set('consent_statistics', value, {
      expires: CookiesExpirationTime,
    });
    Cookies.set('consent_marketing', value, {
      expires: CookiesExpirationTime,
    });

    if (value === 'given') {
      grantCookiesGtm('all');
    } else {
      denyCookiesGtm('all');
    }
  }

  // Set the global consent cookie
  Cookies.set('cookies_bar_consent', 'given', {
    expires: CookiesExpirationTime,
  });

  cookiesBar.classList.remove('is-active');

  if (cookiesSaveNotice) {
    cookiesSaveNotice.classList.remove('hidden');
    setTimeout(() => {
      cookiesSaveNotice.classList.add('hidden');
    }, 2000);
  }
}

// Accept all cookies from Cookie bar
if (cookiesBarAccept) {
  cookiesBarAccept.addEventListener('click', () => {
    cookiesSwitchers.forEach((el) => {
      el.checked = true;
      el.closest('.js-vc-toggle-container').classList.add('is-checked');
    });
    save_cookies_settings('cookieBar', 'given');
  });
}

// Deny all cookies from Cookie bar
if (cookiesBarDeny) {
  cookiesBarDeny.addEventListener('click', () => {
    cookiesSwitchers.forEach((el) => {
      el.checked = false;
      el.closest('.js-vc-toggle-container').classList.remove('is-checked');
    });
    save_cookies_settings('cookieBar', 'rejected');
  });
}

if (cookiesSwitchers) {
  if (cookiesAcceptAllBtn) {
    cookiesAcceptAllBtn.addEventListener('click', () => {
      cookiesSwitchers.forEach((el) => {
        el.checked = true;
        el.closest('.js-vc-toggle-container').classList.add('is-checked');
      });
      save_cookies_settings('cookieSwitchers');
    });
  }

  if (cookiesDenyAllBtn) {
    cookiesDenyAllBtn.addEventListener('click', () => {
      cookiesSwitchers.forEach((el) => {
        el.checked = false;
        el.closest('.js-vc-toggle-container').classList.remove('is-checked');
      });
      save_cookies_settings('cookieSwitchers');
    });
  }

  if (cookiesSaveBtn) {
    cookiesSaveBtn.addEventListener('click', () => {
      save_cookies_settings('cookieSwitchers');
    });
  }

  cookiesSwitchers.forEach((el) => {
    el.addEventListener('change', (event) => {
      const checkboxEl = event.target;
      if (checkboxEl.checked) {
        checkboxEl.closest('.js-vc-toggle-container').classList.add('is-checked');
      } else {
        checkboxEl.closest('.js-vc-toggle-container').classList.remove('is-checked');
      }
    });
  });
}

/**
 * Get URL parameter by name
 * @param {String} name
 * @returns {String}
 */
function getParameterByName(name) {
  name = name.replace(/[[]/, '[').replace(/[\]]/, ']');
  var regex = new RegExp(`[\\?&]${name}=([^&#]*)`),
    results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

/**
 * Set cookies based on URL parameters
 */
function setUrlParamCookies() {
  const cookieParams = [
    { param: 'ref', cookie: 'ws_referral_token' },
    { param: 'gclid', cookie: 'gclid' },
  ];

  const domain = window.location.hostname.split('.').slice(-2).join('.');

  cookieParams.forEach(({ param, cookie }) => {
    const value = getParameterByName(param);
    if (value && !Cookies.get(cookie)) {
      Cookies.set(cookie, value, { expires: 14, domain: domain, path: '/' });
    }
  });
}

// Initialize cookies values
document.addEventListener('DOMContentLoaded', function () {
  if (Cookies.get('cookies_bar_consent') === undefined) {
    if (cookiesBar) {
      cookiesBar.classList.add('is-active');
    }
  }

  cookieTypes.forEach((type) => {
    if (Cookies.get(`consent_${type}`) === 'given') {
      grantCookiesGtm(type);
      if (cookiesSwitchers) {
        cookiesSwitchers.forEach((el) => {
          if (el.getAttribute('data-cookies-type') === type) {
            el.checked = true;
            el.closest('.js-vc-toggle-container').classList.add('is-checked');
          }
        });
      }
    }
  });

  setUrlParamCookies();
});

/**
 * Create/Update Cookie
 *
 * @param {String} name
 * @param {String} value
 * @param {String} days
 */
export const createCookie = (name, value, days) => {
  let expires;

  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toGMTString()}`;
  } else {
    expires = '';
  }
  document.cookie = `${name}=${value}${expires}; path=/`;
};

/**
 * Get Cookie value by name
 *
 * @param {String} name
 * @return {String|False}
 */
export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }

  return false;
};
